import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="card">
          <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">
            Page non trouvée
          </h2>
          <p className="text-gray-600 mb-6">
            La page que vous recherchez n'existe pas.
          </p>
          <Link to="/" className="btn btn-primary inline-block">
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
